import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllHouses = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataHouses, setDataHouses] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllHouses, setLoadingFetchAllHouses ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/houses`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllHouses(true)
        fetchData()
            .then((resp) => {
                setDataHouses(resp.rows)
                setLoadingFetchAllHouses(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllHouses(false)
            })
    }, [execute])

    return { dataHouses, loadingFetchAllHouses, executeFetch }

}

export const useFetchSpecificHouse = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificHouse, setLoadingFetchSpecificHouse ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idcasa: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/houses/fetch-specific-house/${paramsToSearch.idcasa}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcasa > 0 ){
            setLoadingFetchSpecificHouse(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idcasa: rows[0].idcasa || '',
                        descripcion_corta: rows[0].descripcion_corta || '',
                        descripcion_larga: rows[0].descripcion_larga || '',
                        direccion: rows[0].direccion || '',
                        costo_alquiler: rows[0].costo_alquiler || ''
                    }))
                    setLoadingFetchSpecificHouse(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificHouse(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificHouse, setParamsToSearch, executeFetch }

}